import { Hero } from "./-components/hero"
import { Features } from "./-components/features"
import { Pricing } from "./-components/pricing"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(site)/")({
  component: Index,
})

function Index() {
  return (
    <>
      <Hero />
      <Features />
      <Pricing />
    </>
  )
}
